"use client";

import { Button } from "@/components/buttons/Button";
import { NormalText } from "@/components/text/NormalText";
import { useIsTabStale } from "@/lib/zustand/useIsTabStale";
import { cn } from "@/utils/cn";

// Shown by both the signed-in app and the marketing layout; only the app has the fixed sidebar the bar must clear on large screens
export function StaleTabBanner({
  hasSidebarOffset,
}: {
  hasSidebarOffset: boolean;
}) {
  const isTabStale = useIsTabStale((state) => state.isTabStale);

  if (!isTabStale) {
    return null;
  }

  return (
    // Sticky and not dismissible: every further action in this tab fails the same silent way, so the notice has to stay in view until the reload. role="alert" because it appears in response to a save that just failed.
    <div
      role="alert"
      className={cn(
        "sticky top-0 z-50 flex flex-col items-center justify-center gap-x-10 gap-y-2 bg-primaryLight px-6 py-2.5 sm:flex-row sm:px-3.5",
        hasSidebarOffset && "lg:ml-[var(--sidebar-width)]"
      )}
    >
      <NormalText elementType="span" className="text-center">
        We've updated Audimee. Reload to keep going. Anything not saved in this
        tab will be lost.
      </NormalText>

      <Button
        variant="filled"
        size="sm"
        onClick={() => window.location.reload()}
      >
        Reload page
      </Button>
    </div>
  );
}
